export default __webpack_public_path__ + "static/background-green-a2207391b8ecbbfb95e05d94dd328b83.png";